/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ConflictType,
    ConflictTypeFromJSON,
    ConflictTypeFromJSONTyped,
    ConflictTypeToJSON,
} from './ConflictType';

/**
 * 
 * @export
 * @interface PrtimesMediaListCheckConflictResponse
 */
export interface PrtimesMediaListCheckConflictResponse {
    /**
     * 
     * @type {ConflictType}
     * @memberof PrtimesMediaListCheckConflictResponse
     */
    conflictType: ConflictType;
}

export function PrtimesMediaListCheckConflictResponseFromJSON(json: any): PrtimesMediaListCheckConflictResponse {
    return PrtimesMediaListCheckConflictResponseFromJSONTyped(json, false);
}

export function PrtimesMediaListCheckConflictResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrtimesMediaListCheckConflictResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'conflictType': ConflictTypeFromJSON(json['conflict_type']),
    };
}

export function PrtimesMediaListCheckConflictResponseToJSON(value?: PrtimesMediaListCheckConflictResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'conflict_type': ConflictTypeToJSON(value.conflictType),
    };
}

